import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import FloatingCTA from '../../components/feature/FloatingCTA';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import ServicesSection from './components/ServicesSection';
import WhyChooseUs from './components/WhyChooseUs';
import AboutSection from './components/AboutSection';
import Testimonials from './components/Testimonials';
import ProcessTimeline from './components/ProcessTimeline';
import AIAnswerSection from './components/AIAnswerSection';
import ServiceAreasSection from './components/ServiceAreasSection';
import MidCTA from './components/MidCTA';
import GallerySection from './components/GallerySection';
import FAQSection from './components/FAQSection';
import LeadForm from './components/LeadForm';

export default function HomePage() {
  return (
    <main>
      <Header />
      <HeroSection />
      <TrustBar />
      <ServicesSection />
      <WhyChooseUs />
      <AboutSection />
      <Testimonials />
      <ProcessTimeline />
      <AIAnswerSection />
      <ServiceAreasSection />
      <MidCTA />
      <GallerySection />
      <FAQSection />
      <LeadForm />
      <Footer />
      <FloatingCTA />
    </main>
  );
}
